import * as i0 from '@angular/core';
import { Directive, HostBinding, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

class CellDirective {
    constructor() {
        this.staticClasses = true;
    }
}
CellDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: CellDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
CellDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: CellDirective, selector: "[sdCell], sd-cell", inputs: { hasDivider: "hasDivider", hasDividerInset: "hasDividerInset", hasDividerCenter: "hasDividerCenter" }, host: { properties: { "class.cell": "this.staticClasses", "class.has-divider": "this.hasDivider", "class.has-divider--inset": "this.hasDividerInset", "class.has-divider--center": "this.hasDividerCenter" } }, exportAs: ["sdCell"], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: CellDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[sdCell], sd-cell',
                    exportAs: 'sdCell',
                }]
        }], propDecorators: { staticClasses: [{
                type: HostBinding,
                args: ['class.cell']
            }], hasDivider: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.has-divider']
            }], hasDividerInset: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.has-divider--inset']
            }], hasDividerCenter: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.has-divider--center']
            }] } });

class CellColDirective {
    constructor() {
        this.staticClasses = true;
    }
}
CellColDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: CellColDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
CellColDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: CellColDirective, selector: "[sdCellCol], sd-cell-col", inputs: { firstElement: "firstElement", hasMaxWidth: "hasMaxWidth", hasNoGutter: "hasNoGutter", isPulledRight: "isPulledRight", isPulledTop: "isPulledTop", isPulledBottom: "isPulledBottom", isCenterH: "isCenterH", isCenterV: "isCenterV" }, host: { properties: { "class.cell__col": "this.staticClasses", "class.first-element": "this.firstElement", "class.has-max-width": "this.hasMaxWidth", "class.has-no-gutter": "this.hasNoGutter", "class.is-pulled-right": "this.isPulledRight", "class.is-pulled-top": "this.isPulledTop", "class.is-pulled-bottom": "this.isPulledBottom", "class.is-center-h": "this.isCenterH", "class.is-center-v": "this.isCenterV" } }, exportAs: ["sdCellCol"], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: CellColDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[sdCellCol], sd-cell-col',
                    exportAs: 'sdCellCol',
                }]
        }], propDecorators: { staticClasses: [{
                type: HostBinding,
                args: ['class.cell__col']
            }], firstElement: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.first-element']
            }], hasMaxWidth: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.has-max-width']
            }], hasNoGutter: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.has-no-gutter']
            }], isPulledRight: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.is-pulled-right']
            }], isPulledTop: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.is-pulled-top']
            }], isPulledBottom: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.is-pulled-bottom']
            }], isCenterH: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.is-center-h']
            }], isCenterV: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.is-center-v']
            }] } });

class CellRowDirective {
    constructor() {
        this.staticClasses = true;
        // size
        this.size = 100;
    }
    get sizeClass() {
        return this.size && `cell-size-${this.size}`;
    }
    get size50() {
        return Number(this.mobilesize) === 50;
    }
    get size100() {
        return Number(this.mobilesize) === 100;
    }
    get size200() {
        return Number(this.mobilesize) === 200;
    }
    get size300() {
        return Number(this.mobilesize) === 300;
    }
    get size400() {
        return Number(this.mobilesize) === 400;
    }
    get size500() {
        return Number(this.mobilesize) === 500;
    }
    get tabindexAttr() {
        return this.clickable ? 0 : null;
    }
}
CellRowDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: CellRowDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
CellRowDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: CellRowDirective, selector: "[sdCellRow], sd-cell-row", inputs: { size: "size", mobilesize: "mobilesize", clickable: "clickable" }, host: { properties: { "class.cell__row": "this.staticClasses", "class": "this.sizeClass", "class.mobile-cell-size-50": "this.size50", "class.mobile-cell-size-100": "this.size100", "class.mobile-cell-size-200": "this.size200", "class.mobile-cell-size-300": "this.size300", "class.mobile-cell-size-400": "this.size400", "class.mobile-cell-size-500": "this.size500", "class.cell--clickable": "this.clickable", "attr.tabindex": "this.tabindexAttr" } }, exportAs: ["sdCellRow"], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: CellRowDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[sdCellRow], sd-cell-row',
                    exportAs: 'sdCellRow',
                }]
        }], propDecorators: { staticClasses: [{
                type: HostBinding,
                args: ['class.cell__row']
            }], size: [{
                type: Input
            }], sizeClass: [{
                type: HostBinding,
                args: ['class']
            }], mobilesize: [{
                type: Input
            }], size50: [{
                type: HostBinding,
                args: ['class.mobile-cell-size-50']
            }], size100: [{
                type: HostBinding,
                args: ['class.mobile-cell-size-100']
            }], size200: [{
                type: HostBinding,
                args: ['class.mobile-cell-size-200']
            }], size300: [{
                type: HostBinding,
                args: ['class.mobile-cell-size-300']
            }], size400: [{
                type: HostBinding,
                args: ['class.mobile-cell-size-400']
            }], size500: [{
                type: HostBinding,
                args: ['class.mobile-cell-size-500']
            }], clickable: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.cell--clickable']
            }], tabindexAttr: [{
                type: HostBinding,
                args: ['attr.tabindex']
            }] } });

class SmartDesignCellModule {
}
SmartDesignCellModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: SmartDesignCellModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SmartDesignCellModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: SmartDesignCellModule, declarations: [CellDirective, CellColDirective, CellRowDirective], imports: [CommonModule], exports: [CellDirective, CellColDirective, CellRowDirective] });
SmartDesignCellModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: SmartDesignCellModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: SmartDesignCellModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CellDirective, CellColDirective, CellRowDirective],
                    imports: [CommonModule],
                    exports: [CellDirective, CellColDirective, CellRowDirective],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { CellColDirective, CellDirective, CellRowDirective, SmartDesignCellModule };
